import { render } from "./skills-and-tools.vue?vue&type=template&id=bd08beec"
import script from "./skills-and-tools.vue?vue&type=script&lang=js"
export * from "./skills-and-tools.vue?vue&type=script&lang=js"

import "./skills-and-tools.vue?vue&type=style&index=0&id=bd08beec&lang=css"
script.render = render

export default script